export const PRODUCT_IMAGES = {
  hero: '/images/hero-section.jpeg',
  plates: '/images/products/Paper-Plates1 (1).png',
  foodWrap: '/images/products/food-wrap-papper (1).png',
  foodWrap2: '/images/products/food-wrap-papper (2).png',
  foodWrap3: '/images/products/food-wrap-papper (3).png',
  foodWrap4: '/images/products/food-wrap-papper (4).png',
  cupSleeves: '/images/products/Paper-Cup-Sleeves.jpeg',
  cupSleeves2: '/images/products/Paper-Cup-Sleev.png',
  ripple: '/images/products/Ripple-Paper-Cup-Sleeves.jpeg',
  ripple2: '/images/products/Ripple-sleeve1 (2).jpeg',
  coated: '/images/products/coated-rolls.jpeg',
  peCoated: '/images/products/pe-rolls.png',
  peCoatedClassic: '/images/products/pe-coated-rolls.png',
  bobbins: '/images/products/bobbins.jpeg',
  notebook1: '/images/products/Notebook- Cover1 (1).png',
  notebook2: '/images/products/Notebook- Cover1 (2).png',
  peSilver1: '/images/products/PE-Silver-Coated-Envelope-Paper1 (1).png',
  peSilver2: '/images/products/PE-Silver-Coated-Envelope-Paper1 (2).png',
  peSilver3: '/images/products/PE-Silver-Coated-Envelope-Paper1 (3).png',
  soap1: '/images/products/Soap-Stiffener-Paper1 (1).png',
  soap2: '/images/products/Soap-Stiffener-Paper1 (2).png',
  packaging1: '/images/products/packaging1 (1).png',
  packaging2: '/images/products/packaging1 (2).png',
  packaging3: '/images/products/packaging1 (3).png',
  sugar1: '/images/products/Sugar-Sachets1 (1).png',
  sugar2: '/images/products/Sugar-Sachets1 (2).png',
  pouches1: '/images/products/Pouches-Rolls1 (1).png',
  pouches2: '/images/products/Pouches-Rolls1 (2).png',
  pouches3: '/images/products/Pouches-Rolls1 (3).png',
  pouches4: '/images/products/Pouches-Rolls1 (4).png',
  cupBottom1: '/images/products/Cup-Bottoms1 (1).png',
  cupBottom2: '/images/products/Cup-Bottoms1 (2).png',
  cupBottom3: '/images/products/Cup-Bottoms1 (3).png',
  container1: '/images/products/Container-Sleeves1 (1).png',
  container2: '/images/products/Container-Sleeves1 (2).png',
  container3: '/images/products/Container-Sleeves1 (3).png',
  container4: '/images/products/Container-Sleeves1 (4).png',
  boxTray1: '/images/products/Box-Tray1 (1).png',
  boxTray2: '/images/products/Box-Tray1 (2).png',
};

export const websiteLink = {
  label: 'info@greeneripapers.com',
  href: 'mailto:info@greeneripapers.com',
};

export const overlapHero = (title, paragraphs, overlaySrc, mainSrc, overlayAlt, mainAlt) => ({
  title,
  paragraphs,
  overlayImage: { src: overlaySrc, alt: overlayAlt },
  mainImage: { src: mainSrc, alt: mainAlt },
});

export const cardGridHero = (subTitle, mainTitleLines, cardTitle, cardParagraphs, images) => ({
  subTitle,
  mainTitleLines,
  cardTitle,
  cardParagraphs: Array.isArray(cardParagraphs) ? cardParagraphs : [cardParagraphs],
  website: websiteLink,
  images,
});

export const presentationHero = (
  badge,
  scriptTitle,
  boldTitle,
  descHeading,
  descParagraphs,
  images
) => ({
  badge,
  scriptTitle,
  boldTitle,
  descHeading,
  descParagraphs,
  images,
});

export const foodWrapHero = (
  badge,
  scriptTitle,
  boldTitle,
  descriptions,
  features,
  imageLeft,
  imageRight
) => ({
  badge,
  scriptTitle,
  boldTitle,
  descriptions,
  features,
  imageLeft: { src: imageLeft, alt: `${boldTitle} material` },
  imageRight: { src: imageRight, alt: `${boldTitle} manufacturing` },
});

export const bannerOverlayHero = (
  badge,
  scriptTitle,
  boldTitle,
  descriptions,
  features,
  bannerImage,
  accentImage
) => ({
  badge,
  scriptTitle,
  boldTitle,
  descriptions,
  features,
  bannerImage: { src: bannerImage, alt: boldTitle },
  accentImage: accentImage
    ? { src: accentImage, alt: `${boldTitle} detail` }
    : null,
});

export const peCoatedHero = (
  badge,
  scriptTitle,
  boldTitle,
  descriptions,
  mainImage,
  bannerImage
) => ({
  badge,
  scriptTitle,
  boldTitle,
  descriptions,
  mainImage: { src: mainImage, alt: boldTitle },
  bannerImage: { src: bannerImage, alt: 'Industrial paper manufacturing' },
});

export const cupSleeveHero = (
  badge,
  scriptTitle,
  mainTitleLines,
  kicker,
  descriptions,
  features,
  imagePrimary,
  imageSecondary
) => ({
  badge,
  scriptTitle,
  mainTitleLines,
  kicker,
  descriptions,
  features,
  imagePrimary: { src: imagePrimary, alt: mainTitleLines.join(' ') },
  imageSecondary: { src: imageSecondary, alt: `${mainTitleLines.join(' ')} in café service` },
});

export const rippleSleeveHero = (
  badge,
  scriptTitle,
  mainTitleLines,
  kicker,
  descriptions,
  features,
  imagePrimary,
  imageSecondary,
  stampLabel = 'Triple Layer'
) => ({
  badge,
  scriptTitle,
  mainTitleLines,
  kicker,
  descriptions,
  features,
  imagePrimary: { src: imagePrimary, alt: mainTitleLines.join(' ') },
  imageSecondary: { src: imageSecondary, alt: `${mainTitleLines.join(' ')} detail` },
  stampLabel,
});

export const sugarSachetHero = (
  badge,
  scriptTitle,
  mainTitleLines,
  kicker,
  descriptions,
  features,
  imagePrimary,
  imageSecondary
) => ({
  badge,
  scriptTitle,
  mainTitleLines,
  kicker,
  descriptions,
  features,
  imagePrimary: { src: imagePrimary, alt: mainTitleLines.join(' ') },
  imageSecondary: { src: imageSecondary, alt: `${mainTitleLines.join(' ')} packaging` },
});
